import { render, staticRenderFns } from "./prePage.vue?vue&type=template&id=1f252aac&scoped=true&"
import script from "./prePage.vue?vue&type=script&lang=js&"
export * from "./prePage.vue?vue&type=script&lang=js&"
import style0 from "./prePage.vue?vue&type=style&index=0&id=1f252aac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f252aac",
  null
  
)

export default component.exports